import dayjs from 'dayjs';

export const formatDate = (date: Date | string): string => {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Brussels',
    dateStyle: 'short'
  }).format(new Date(date));
};

export const formatTime = (date: Date | string): string => {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Brussels',
    timeStyle: 'short'
  }).format(new Date(date));
};

export const formatDateTime = (date: Date | string): string => {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Brussels',
    timeStyle: 'short',
    dateStyle: 'short'
  }).format(new Date(date));
};

export const numberOfMonthsUntilNow = (date: Date | string): number => {
  return Math.abs(dayjs().diff(dayjs(date), 'month'));
};
